export enum RulingStatus {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  SUBMITTED_WITHDRAWAL_REQUESTED = 'SUBMITTED_-_WITHDRAWAL_REQUESTED',
  ASSIGNED = 'ASSIGNED',
  ASSIGNET_WITHDRAWAL_REQUESTED = 'ASSIGNED_-_WITHDRAWAL_REQUESTED',
  IN_PROGRESS = 'IN_PROGRESS',
  IN_PROGRESS_WITHDRAWAL_REQUESTED = 'IN_PROGRESS_-_WITHDRAWAL_REQUESTED',
  WAITING_FOR_ADDITIONAL_INFORMATION = 'WAITING_FOR_ADDITIONAL_INFORMATION',
  WAITING_FOR_ADDITIONAL_INFORMATION_WITHDRAWAL_REQUESTED = 'WAITING_FOR_ADDITIONAL_INFORMATION_-_WITHDRAWAL_REQUESTED',
  POSTPONED = 'POSTPONED',
  CANCELLED = 'CANCELLED',
  DECISION_RENDERED = 'DECISION_RENDERED',
  DECISION_RENDERED_WITHDRAWAL_REQUESTED = 'DECISION_RENDERED_-_WITHDRAWAL_REQUESTED',
  MODIFIED = 'MODIFIED',
  DECISION_MODIFIED = 'DECISION_MODIFIED',
  REVOKED = 'REVOKED',
  DECISION_REVOKED = 'DECISION_REVOKED',
  REJECTED = 'REJECTED',

  CLOSED = 'CLOSED',
  WITHDRAWN = 'WITHDRAWN',
  WITHDRAWN_WITHDRAWAL_REQUESTED = 'WITHDRAWN_-_WITHDRAWAL_REQUESTED',
}

export enum RulingCategory {
  AR = 'AR',
  NCR = 'NCR',
  SCR = 'SCR',
}

// string values are keys in the json files for translation
export enum RulingStepPageShortDescription {
  RulingContext = 'rulings_forms.rulingStep.new.shortDescription',

  RulingDetails = 'rulings_forms.rulingStep.ruling_details.shortDescription',
  Valuation = 'rulings_forms.rulingStep.valuation.shortDescription',
  TariffClassification = 'rulings_forms.rulingStep.tariff_classification.shortDescription',
  Origin = 'rulings_forms.rulingStep.origin.shortDescription',
  NonFtaOrigin = 'rulings_forms.rulingStep.non_fta_origin.shortDescription',
  Marking = 'rulings_forms.rulingStep.marking.shortDescription',
  NonFtaMarking = 'rulings_forms.rulingStep.non_fta_marking.shortDescription',
  CittTextileTariffReliefInvestigation = 'rulings_forms.rulingStep.citt_textile_tariff_relief_investigation.shortDescription',
  SameCondition = 'rulings_forms.rulingStep.same_condition.shortDescription',
}

// string values are keys in the json files for translation
// the stepper pipes this value to the translator in the view
export enum RulingSteps {
  RulingContext = 'rulings_forms.rulingStep.new.label',
  RulingDetails = 'rulings_forms.rulingStep.ruling_details.label',
  Valuation = 'rulings_forms.rulingStep.valuation.label',
  TariffClassification = 'rulings_forms.rulingStep.tariff_classification.label',
  Origin = 'rulings_forms.rulingStep.origin.label',
  NonFtaOrigin = 'rulings_forms.rulingStep.non_fta_origin.label',
  Marking = 'rulings_forms.rulingStep.marking.label',
  NonFtaMarking = 'rulings_forms.rulingStep.non_fta_marking.label',
  CittTextileTariffReliefInvestigation = 'rulings_forms.rulingStep.citt_textile_tariff_relief_investigation.label',
  SameCondition = 'rulings_forms.rulingStep.same_condition.label',
}

export enum RulingConfirmationMode {
  NEW_REQUEST,
  MODIFY_REQUEST,
}

export enum RulingType {
  VALUATION = 'VALUATION',
  TARIFF_CLASSIFICATION = 'TARIFF_CLASSIFICATION',
  ORIGIN = 'ORIGIN',
  MARKING = 'MARKING',
  NON_FTA_MARKING = 'NON_FTA_MARKING',
  NON_FTA_ORIGIN = 'NON_FTA_ORIGIN',
  CITT_TEXTILE_TARIFF_RELIEF_INVESTIGATION = 'CITT_TEXTILE_TARIFF_RELIEF_INVESTIGATION',
  SAME_CONDITION = 'SAME_CONDITION',
}
